import moment, { type Moment } from 'moment-timezone';

// We generally prefer using moment objects instead of Javascript date objects
//  to be consistent. But these functions are here if you really need them.

export const isJavascriptDate = (obj: unknown): obj is Date =>
    Object.prototype.toString.call(obj) === '[object Date]';

export const areJavascriptDatesEqual = (date1: Date, date2: Date): boolean =>
    date1.getTime() === date2.getTime();

// Normalize an API date (Date, Moment, or the ISO string uncached responses return)
// to a real JS Date. moment() avoids new Date's UTC off-by-one on date-only strings.
export function coerceToDate(value: Date | string | Moment): Date;
export function coerceToDate(value: Date | string | Moment | null | undefined): Date | undefined;
export function coerceToDate(value: Date | string | Moment | null | undefined): Date | undefined {
    return value == null ? undefined : moment(value).toDate();
}

// The calendar day in `timezone`, at UTC midnight. For date-only fields the backend
// reads the day off the UTC instant we send.
export const toUtcCalendarDay = (value: Date | string | Moment, timezone: string): Date =>
    new Date(`${moment.tz(value, timezone).format('YYYY-MM-DD')}T00:00:00Z`);

// The browser-local calendar day of `value`, as the start of that same day in `timezone`.
export const calendarDayIn = (value: Date, timezone: string): Moment =>
    moment.tz(moment(value).format('YYYY-MM-DD'), timezone);
